import { on } from '@ngrx/store';
import moment from 'moment';

import { rangeActions } from '../actions';
import { IDashboardState } from '../states';

const onResetDatesValues = on(rangeActions.resetRangeValues, (state: IDashboardState) => {
  return {
    ...state,
    range: {
      ...state.range,
      startDateValue: moment().valueOf(),
      endDateValue: moment().valueOf(),
      isReset: true,
    },
  };
});

const onSetStartDateValue = on(rangeActions.setStartDateValue, (state: IDashboardState, { startDateValue }) => ({
  ...state,
  range: {
    ...state.range,
    startDateValue,
    isReset: false,
  },
}));

const onSetEndDateValue = on(rangeActions.setEndDateValue, (state: IDashboardState, { endDateValue }) => ({
  ...state,
  range: {
    ...state.range,
    endDateValue,
    isReset: false,
  },
}));

const onSetIsLoading = on(rangeActions.setIsLoading, (state: IDashboardState, { isLoading }) => ({
  ...state,
  range: {
    ...state.range,
    isLoading,
  },
}));

const rangeActionHandlersArr = [onResetDatesValues, onSetStartDateValue, onSetEndDateValue, onSetIsLoading];

export default rangeActionHandlersArr;
